module.exports = __webpack_public_path__ + "img/close-icon.be5676a5.svg";